import { Producto } from "./producto";

export class GuiaremisionDetalle {
    constructor(
        public cantidad: number = 0,
        public producto: Producto = new Producto(),
        public detalle: String = "",
        public producto_id: String = "", 
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public usuario_id:String = null
    ){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/guiaremision_detalle.ts